<template>
  <div class="col-md-12">
    <div class="list">
      <div class="list__header">
        <span class="list__title">{{ title }} <span v-if="totalItems">| <b>{{ totalItems }}</b> itens</span></span>
        <div v-if="haveExcel && !emptyState" class="list__btn">
          <btn-excel @emit-event-excel="onClickExcel()" :loading="loadingExcel"/>
        </div>
      </div>
      <empty-state v-if="emptyState"/>
      <div v-else class="list__body">
        <table class="table">
          <thead>
          <tr>
            <th v-for="(value, index) in columnsListHeader" :key="index">
              {{ value }}
            </th>
          </tr>
          </thead>
          <tbody>
          <slot/>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import BtnExcel from "../buttons/btnExcel.vue";
import EmptyState from "./emptyState.vue";
import Pagination from "../tools/pagination.vue";

export default {
  name: "boxListing",
  components: {Pagination, EmptyState, BtnExcel},
  props: {
    title: {
      required: true,
    },
    columnsListHeader: {
      required: true,
    },
    haveExcel: {
      default: false,
    },
    emptyState: {
      required: true,
      default: false
    },
    totalItems: {
      default: '',
    },
    loadingExcel: {
      default: '',
    }
  },
  methods: {
    onClickExcel() {
      this.$emit('emit-excel')
    }
  }
};
</script>

<style lang="scss" scoped>
/* Seletor de bloco */
.list {
  background: #FFFFFF;
  border-radius: 10px !important;
  padding: 30px 20px;
  margin: 30px 0 60px 0;

  /* Seletor de elemento */
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__header > &__title {
    font-weight: 400;
    font-size: 21px;
    color: #191919;
  }

  &__body {
    overflow: auto;
    margin-top: 30px;

    table {
      thead {
        tr {
          border-bottom: 1px solid #E6E9EC;

          th {
            padding-bottom: 5px;
            font-weight: 400;
            font-size: 14px;
            color: #7F8897;
            border: none;
            min-width: 146px;
          }
        }
      }

      tbody {
        .table-tr {
          td {
            padding-top: 15px !important;
            padding-bottom: 15px !important;
            font-weight: 400;
            font-size: 16px;
            color: #3A424E;
            vertical-align: inherit !important;

            a {
              font-weight: 400;
              font-size: 14px;
              color: #2F23D6;
              text-decoration: none;
              border-bottom: 1px solid transparent;
              transition: .2s;

              &:hover {
                border-color: #2F23D6;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/layouts/boxListing.vue